/* Menu Entry Template:
{
  name: 'Name that appears in menu',
  id: 'Unique identifier for specific tile',
  content: [{
    id: 'data-src-ID',
    type: 'line/bar/dotplot/table/image'
  }],
  components: ['toggles', 'tabs']
},
*/

export default {
  label: 'Driving Study',
  id: 'driving',
  sidebar: [
    {
      li: 'Study Overview',
      subList: [
        {
          name: 'Study Design',
          tileId: 'driving-study-design',
          content: [{
            id: 'driving-study-design',
            type: 'image',
          }],
          tooltip: '<p>Key Inclusion Criteria: adults with OSA currently using primary OSA therapy (eg, positive airway pressure [PAP]) or with ≥1 month history of attempting to use a primary OSA therapy or with history of surgical intervention for OSA; ESS score ≥10; MWT sleep latency <30 min.</p>' +
            '<p>Treatments: 7 d of placebo or solriamfetol (150 mg/d x 3 d, then 300 mg/d x 4 d) followed by crossover to the other treatment for 7 d.</p>',
          components: [],
        },
        {
          name: 'SDLP Assessment Scale',
          tileId: 'driving-sdlp-assessment-scale',
          content: [{
            id: 'driving-sdlp-assessment-scale',
            type: 'image',
          }],
          components: [],
        },
        {
          name: 'Baseline Characteristics',
          tileId: 'driving-baseline-characteristics',
          content: [{
            id: 'driving-baseline-char',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
    {
      li: 'Efficacy',
      subList: [
        {
          name: 'SDLP Analysis',
          tileId: 'driving-sdlp-analysis',
          content: [{
            id: 'driving-sdlp-analysis',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
        {
          name: 'SDLP Individual Performance',
          tileId: 'driving-sdlp-individual-performance',
          content: [{
            id: 'driving-sdlp-indiv',
            type: 'dotplot',
          }],
          components: [],
        },
        {
          name: 'Percent Improvement',
          tileId: 'driving-percent-improvement',
          content: [{
            id: 'driving-percent-improvement',
            type: 'image',
          }],
          components: [],
        },
        {
          name: 'Secondary Endpoints',
          tileId: 'driving-2-endpoints',
          content: [{
            id: 'driving-secondary-endpts',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
    {
      li: 'Safety',
      subList: [
        {
          name: 'TEAEs',
          tileId: 'driving-teaes',
          content: [{
            id: 'driving-teaes',
            type: 'table',
          }],
          components: [],
        },
      ],
    },
  ],
};
